import {
  DEFAULT_UI_LOCALE,
  type UiLocale,
} from "../i18n";
import type { Scenario, ScenarioId } from "./types";

type ScenarioCopy = Pick<
  Scenario,
  "name" | "title" | "shortLabel" | "description"
>;

const ENGLISH_SCENARIO_COPY: Readonly<
  Record<ScenarioId, ScenarioCopy>
> = {
  sunny: {
    name: "Easy Sunshine",
    title: "Easy Sunshine",
    shortLabel: "Clear",
    description:
      "Most holdings are gently up in warm sunlight. Only KO looks a little glum.",
  },
  party: {
    name: "Portfolio Party",
    title: "Portfolio Party",
    shortLabel: "Party",
    description:
      "Tech holdings are leaping, so the whole home turns into a party. KO is down on its own.",
  },
  moonshot: {
    name: "Moonshot Festival",
    title: "Moonshot Festival",
    shortLabel: "Moonshot",
    description:
      "The portfolio shoots upward as money rain and disco lights take over the farm.",
  },
  storm: {
    name: "Heavy Shower",
    title: "Heavy Shower",
    shortLabel: "Storm",
    description:
      "The portfolio is soaked, but NVDA is still bouncing happily on its own.",
  },
  panic: {
    name: "Market Panic",
    title: "Market Panic",
    shortLabel: "Panic",
    description:
      "Lightning and embers fill the home. Defensive KO is the only one wearing a small smile.",
  },
  catastrophe: {
    name: "Market Catastrophe",
    title: "Market Catastrophe",
    shortLabel: "Catastrophe",
    description:
      "The portfolio plunges as floodwater, flames, and exhausted Tickerlings overwhelm the farm.",
  },
};

const NON_DEFAULT_SCENARIO_COPY = {
  en: ENGLISH_SCENARIO_COPY,
} as const satisfies Readonly<
  Record<
    Exclude<UiLocale, typeof DEFAULT_UI_LOCALE>,
    Readonly<Record<ScenarioId, ScenarioCopy>>
  >
>;

export function localizeScenario(
  scenario: Scenario,
  locale: UiLocale,
): Scenario {
  if (locale === DEFAULT_UI_LOCALE) {
    return scenario;
  }
  const copy: ScenarioCopy =
    NON_DEFAULT_SCENARIO_COPY[
      locale as Exclude<UiLocale, typeof DEFAULT_UI_LOCALE>
    ][scenario.id];
  return {
    ...scenario,
    ...copy,
  };
}
